import { TreeNode } from "@/types/tree";
import { ClipboardData } from "@/types/copy-paste";

export function getClipboardDataForElementOrElements(
  elementOrElements: TreeNode | TreeNode[]
): ClipboardData {
  return {
    element: elementOrElements
  };
}
